import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_profile_roles: { message: "idle" },
};

export const retrieve_tenant_profile_roles_Slice = createSlice({
 name: "retrieve_tenant_profile_roles",
 initialState,
 reducers: {
  success_retrieve_tenant_profile_roles: (state, action) => {
   state.retrieve_tenant_profile_roles = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_profile_roles: (state, action) => {
   state.retrieve_tenant_profile_roles = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_profile_roles: (state) => {
   state.retrieve_tenant_profile_roles = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_profile_roles: (state) => {
   state.retrieve_tenant_profile_roles = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_profile_roles, fail_retrieve_tenant_profile_roles, reset_retrieve_tenant_profile_roles, loading_retrieve_tenant_profile_roles } = retrieve_tenant_profile_roles_Slice.actions;

export default retrieve_tenant_profile_roles_Slice.reducer;